var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-footer"},[_c('div',{staticClass:"site-guide"},[_c('router-link',{attrs:{"to":{ name: 'SiteGuide'},"title":"Site Guide ReShaping"}},[_vm._v("Site Guide")])],1),_vm._v(" "),_c('div',{staticClass:"jxp-footer-content",attrs:{"id":"phmGlobalFooter"}},[_vm._v("Loading Global Footer... ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5808cbd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 